import React,{ Component } from "react";
import { Menu,notification, Dropdown, Icon, Card, Button, Row, Col, Spin, message } from 'antd';
import moment from 'moment'
import Axios from "axios"
import {basicPlanPrice,proPlanPrice} from "../../../../../config/fbConfig"
import {CLOUD_FUNCTION} from "../../../../../config/fbConfig"
const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'Notification',
      description: 'Congratulations! your plan has been updated successful.',
    });
  };
  const openNotificationWithIcon2 = (type) => {
    notification[type]({
      message: 'Notification',
      description: 'Please add a payment card to your account',
    });
  };
export default class Subscriptioncard extends Component{

    constructor(props){
        super(props);
        this.state={
            pricingPlans:[],
            switchingPlan:false,
        }
    }

    componentWillMount() {
       this.initializePlan(this.props)
    }
    initializePlan=(props)=>{
        var {profile} = props
        var plans= [
            { id: 1, title: 'free', package:"Monthly", price: 0, users: 4, storage: 2 },
            { id: 2, title: 'basic', package:"Monthly", price: basicPlanPrice, users: 8, storage: 5 },
            { id: 3, title: 'pro',  package:"Yearly", price: proPlanPrice, users: 12, storage: 7 },
            ]
           var pricingPlans= plans.filter((plan)=> (profile.plan !== plan.title))
            this.setState({pricingPlans,profile:props.profile})
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.auth.changePlanSuccess === true){
            this.initializePlan(nextProps)
            openNotificationWithIcon('success')
        }
    }
    switchPlan = (plan)=>{
        this.setState({switchingPlan:true});
       var {profile,cards} = this.props;
       if(cards.length ===0 && plan.title !== "free")  {
           openNotificationWithIcon2("error");
           this.setState({switchingPlan:false});
           return false
       }
       if(plan.title==="free"){
        var current_period_end = profile.current_period_end ? profile.current_period_end:moment().unix();
       }else if(plan.title==="basic"){
        var current_period_end = profile.current_period_end ? moment.unix(profile.current_period_end).add('1','M').unix():moment().add('1','M').unix();
        if(profile.trial.plan && profile.trial.reset === false){
            var unusedDays = moment.unix(profile.current_period_end).diff(moment(),'days')
            current_period_end =  moment().add('1','M').add(unusedDays,'days').unix()
        }
    }
       else if(plan.title==="pro"){
        var current_period_end = profile.current_period_end ? moment.unix(profile.current_period_end).add('1','Y').unix():moment().add('1','Y').unix();
        if(profile.trial.plan && profile.trial.reset === false){
            var unusedDays = moment.unix(profile.current_period_end).diff(moment(),'days')
            current_period_end =  moment().add('1','Y').add(unusedDays,'days').unix()
        }
      
    }
       Axios.post(`${CLOUD_FUNCTION}/api/change_plan`,{plan:plan.title,current_period_end,profile })
       .then((res)=>{
           console.log(res)
        if(res.data.message){
            var subscriptionId="";
            if(res.data.subscription) subscriptionId=res.data.subscription.id
            var data={
                subscription:{
                    customerId:profile.subscription.customerId,
                    subscriptionId
                },
                status: {
                  completed: true
                },
                current_period_end,
                plan:plan.title,
                trial:{plan:profile.plan ==="free" ?plan.title:profile.plan ,endAt:profile.current_period_end,reset:false}
            }
            //reset
            if(plan.title ==="free") data.trial.reset = true
            this.props.changePlan(profile.uid,data)
            
        }else if(res.data.error) {
            message.error(res.data.error.message)
        }
        this.setState({switchingPlan:false})
       
           // window.location.assign('/');
       }).catch((error)=>{
           console.log(error)
           this.setState({switchingPlan:false})
       })
    }

    upgradeMenu=()=>{
    var {pricingPlans}= this.state;
    // var  planIndex = plans.findIndex((plan)=>profile.plan === plan.title)
     pricingPlans= pricingPlans.filter((plan)=> (plan.title !== "free"))
        const menu = <Menu>
        {pricingPlans.map((plan,key)=>(
            <Menu.Item key={key}>
                <div onClick={()=>this.switchPlan(plan)}>{plan.title} plan</div>
             </Menu.Item>
                ))}
            </Menu>
      return menu;
    }

    downgradeMenu=()=>{
        var {pricingPlans}= this.state;
        // var  planIndex = plans.findIndex((plan)=>profile.plan === plan.title)
         pricingPlans= pricingPlans.filter((plan)=> (plan.title !== "pro"))
            const menu = <Menu>
            {pricingPlans.map((plan,key)=>(
                <Menu.Item key={key}>
                    <div onClick={()=>this.switchPlan(plan)}>{plan.title} plan</div>
                 </Menu.Item>
                    ))}
                </Menu>
          return menu;
        }
    render(){
        var {profile} = this.props
        return(
            <Spin spinning={this.state.switchingPlan}>
            <Card
                className="subscription-card"
                title="Subscription Information"
                bordered={false}
                style={{ width: 600 }}
              >
                <h4 className="subscription-head">
                  Subscription Plan: 
                  <span className="plan-name"> {profile.plan}</span>
                </h4>
                {profile.plan==="free"?null:<h4 className="subscription-head">
                  Renew on:
                  <span className="plan-name"> {moment.unix(profile.current_period_end).format('ll')}</span>
                </h4>}
                {/* {profile.plan===profile.trial.plan?null:<h4 className="subscription-head">
                  {profile.trial.plan} plan ends on 
                  <span className="plan-name">{moment.unix(profile.trial.endAt).format('ll')}</span>
                </h4>} */}
                <div className="subscription-controls">
  
                <Dropdown disabled={profile.plan ==="free"?true:false} overlay={this.downgradeMenu} placement="bottomCenter">
                  <Button>Downgrade plan</Button>
                </Dropdown>

                <Dropdown disabled={profile.plan ==="pro"?true:false} overlay={this.upgradeMenu} placement="bottomCenter">
                  <Button  type="primary">Upgrade plan</Button>
                </Dropdown>
                </div>
              </Card>
              </Spin>
        )
    }
}